import * as React from "react";
import { useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Alert } from "components/bootstrap";
import usePermissions from "hooks/usePermissions";
import { useParameterType } from "./ParameterTypes";
const PermissionsAlert = styled(Alert)`
  margin-top: 10px;
`;
const useValidatePermissions = (idx, editPermissions, title, onValidate) => {
  const { isPermitted } = usePermissions();
  const hasEditPermissions = isPermitted(editPermissions);
  useEffect(() => {
    const _validationState = hasEditPermissions ? ["success"] : ["error", ""];
    onValidate(idx, { typeEditPermissions: _validationState });
    return () => onValidate(idx, { typeEditPermissions: ["success"] });
  }, [idx, editPermissions, title, hasEditPermissions, onValidate]);
  return hasEditPermissions;
};
const TypeSpecificDeclarationFields = ({ idx, type, parameter, onChange, validationState, onValidate }) => {
  const { t } = useTranslation("enterprise_common");
  const { editComponent: Component, editPermissions, title } = useParameterType(type);
  const hasEditPermissions = useValidatePermissions(idx, editPermissions, title, onValidate);
  if (!hasEditPermissions) {
    return /* @__PURE__ */ React.createElement(PermissionsAlert, { bsStyle: "danger" }, t("parameters.no_permissions", { title, permissions: editPermissions == null ? void 0 : editPermissions.join(",") }));
  }
  return /* @__PURE__ */ React.createElement(
    Component,
    {
      idx,
      parameter,
      onChange,
      validationState,
      onValidate
    }
  );
};
export default TypeSpecificDeclarationFields;
